import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const TolranceViewItem = ({ data,isLoading }: any) => {
  const report = data?.res || data; // support both data and data.res

  if (!report || !report.categoriesJson?.length || !report.chartSeries?.length) {
     return !isLoading?(<div>No Data Found</div>):(<div>Loading chart...</div>);
  }

  // const options: Highcharts.Options = {
  //   chart: { type: "column" },
  //   title: { text: "Tolerance" },
  //   xAxis: { categories: report.categoriesJson, crosshair: true },
  //   yAxis: { min: 0, title: { text: "TAT (minutes)" } },
  //   tooltip: { shared: true, valueSuffix: " min" },
  //   plotOptions: { column: { borderRadius: 5, pointPadding: 0.2, groupPadding: 0.1 } },
  //   credits: { enabled: false },
  //   series: report.chartSeries.map((s: any) => ({
  //     type: "column",
  //     name: s.name,
  //     data: s.data.map((d: any) => Number(d)),
  //   })),
  // };

   const options: Highcharts.Options = {
        chart: {type: 'line',},
        title: {  text: 'Weight Bridge Tolerance',},
        subtitle: {  useHTML: true, },
        xAxis: { categories:report.categoriesJson || [] ,
        title: {  text: '',},
        },
        yAxis: {  title: { text: 'Weight Bridge Tolerance', }, },
           tooltip: {
          formatter: function () {
            return `<b></b> ${this.y} Kg`;
          }
        },
       plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.y as number;
              }
            }
          }
        },
        credits: {
      enabled: false
    },
        series:report.chartSeries || [] ,
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
